//-------------------- Url集合 --------------------

//开发服
// const ISTEST = 1;
// const IPHONE_TOKEN = "";       //token
// const API_SALES_URL = 'http://172.31.54.84:6221/'; //API路径---销售模块
// const API_PUBLIC_URL = 'http://172.31.54.84:6222/';//API路径---公共查询
// const API_PUBLIC1_URL = 'http://172.31.54.84:6220/';//API路径---公共查询1
// const API_WAIKEY = 'http://172.31.54.84:6237/'; //外键路径
// const API_TOKEN = 'http://172.31.54.84:6255/api/v1/';   //获取操作电话号码
// const VERSION_NUM = "v1"; //版本号
// const API_QC_URL = "http://172.31.54.84:6222/";  //权限
// const API_URL = 'http://172.31.54.84:6222/'; //API路径(luokui)
// const API_WAIKEY_KH = 'http://172.31.54.84:6223/'; //获取外键（通过款号找品名）
// const API_URL_lsp = 'http://172.31.54.84:6220/'; //API路径(luokui)
// const API_IPHONE = '';
// var OSS_KEY = '';
// const SAO_URL = 'http%3a%2f%2f47.105.140.141%3a6255%2fapi%2fv1%2fPublicLogin%2fQRcodeRedirect%3fisuser%3d1';       //企业微信扫码回调路径
// const SAO_AGENTID = '1000027';       //企业微信扫码agentid
// const API_FR_USERS = "cUcnN1*9CmK3";    //帆软
// const loginUrl2020 = "http://user2020.ailend.hk:6503/#/"       //跳转用户2020
// const SAO_CSS = "https://userinfo.ailend.info/login_code.css"

// //测试服
// const ISTEST = 3;
// const IPHONE_TOKEN = "";       //token
// const API_SALES_URL = 'https://cshttps.ailend.hk:9007/'; //API路径---销售模块
// const API_PUBLIC_URL = 'https://cshttps.ailend.hk:9006/';//API路径---公共查询
// const API_PUBLIC1_URL = 'https://cshttps.ailend.hk:9005/';//API路径---公共查询1
// const API_WAIKEY = 'https://cshttps.ailend.hk:9033/'; //外键路径
// const API_TOKEN = 'https://cshttps.ailend.hk:9004/api/v1/';   //获取操作电话号码
// const VERSION_NUM = "v1"; //版本号
// const API_QC_URL = "https://cshttps.ailend.hk:9006/";  //权限
// const API_URL = 'https://cshttps.ailend.hk:9006/'; //API路径(luokui)
// const API_WAIKEY_KH = 'https://cshttps.ailend.hk:9032/'; //获取外键（通过款号找品名）
// const API_URL_lsp = 'https://cshttps.ailend.hk:9005/'; //API路径(luokui)
// const API_IPHONE = '';
// var OSS_KEY = '';
// const SAO_URL = 'https%3A%2F%2Fcshttps.ailend.hk%3A9004%2Fapi%2Fv1%2FPublicLogin%2FQRcodeRedirect%3Fisuser%3D1';       //企业微信扫码回调路径
// const SAO_AGENTID = '1000034';       //企业微信扫码agentid
// const API_FR_USERS = "cUcnN1*9CmK3";    //帆软
// const loginUrl2020 = "http://webtest2020.ailend.info:9011/#/"       //跳转用户2020
// const SAO_CSS = "https://userinfo.ailend.info/login_code.css"

// 正式
const ISTEST = 2;
const IPHONE_TOKEN = "";       //token
const API_SALES_URL = 'https://rs.myailand.org:9030/'; //API路径---销售模块
const API_PUBLIC_URL = 'https://rs.myailand.org:9028/';//API路径---公共查询
const API_PUBLIC1_URL = 'https://rs.myailand.org:9027/';//API路径---公共查询1
const API_WAIKEY = 'https://sms.myailand.org/'; //外键路径
const API_TOKEN = 'https://userinfo.ailend.info/api/v1/';   //获取操作电话号码 原来userinfo.ailend.info
const VERSION_NUM = "v1"; //版本号
const API_QC_URL = "https://rs.myailand.org:9028/";  //权限
const API_URL = 'https://rs.myailand.org:9028/'; //API路径(luokui)
const API_WAIKEY_KH = 'https://rs.myailand.org:9029/'; //获取外键（通过款号找品名）
const API_URL_lsp = 'https://rs.myailand.org:9027/'; //API路径(luokui)
const API_IPHONE = '';
var OSS_KEY = '';
const SAO_URL = 'https%3a%2f%2fuserinfo.ailend.info%2fapi%2fv1%2fPublicLogin%2fQRcodeRedirect%3fisuser%3d1';    //企业微信扫码回调路径
const SAO_AGENTID = '1000028';      //企业微信扫码agentid
const API_FR_USERS = "cUcnN1*9CmK3";    //帆软
const loginUrl2020 = "http://webtest2020.ailend.info:9011/#/"       //跳转用户2020
const SAO_CSS = "https://userinfo.ailend.info/login_code.css"

export default {
    API_SALES_URL,
    API_PUBLIC_URL,
    API_PUBLIC1_URL,
    API_WAIKEY,
    API_TOKEN,
    VERSION_NUM,
    IPHONE_TOKEN,
    API_URL,
    API_WAIKEY_KH,
    API_URL_lsp,
    API_IPHONE,
    OSS_KEY,
    API_QC_URL,
    SAO_URL,
    SAO_AGENTID,
    ISTEST,
    API_FR_USERS,
    loginUrl2020,
    SAO_CSS
 }



// WEBPACK FOOTER //
// ./src/router/url_itembox.js